import { initTheme } from './modules/theme.js';
import { initDir } from './modules/dir.js';
import { initSidebar } from './modules/sidebar.js';
import { initModals } from './modules/modals.js';
import { initAccordion } from './modules/accordion.js';
import { initDropdown } from './modules/dropdown.js';
import { initNotifications } from './modules/notifications.js';
import { initTabs } from './modules/tabs.js';
import { initToast } from './modules/toast.js';
import { initToggleSwitch } from './modules/toggle-switch.js';
import { initPasswordToggle } from './modules/password-toggle.js';
import { initOtpInput } from './modules/otp-input.js';
import { initProgressRing } from './modules/progress-ring.js';
import { initSkeleton } from './modules/skeleton.js';
import { initVideoPlayer } from './modules/video-player.js';
import { initRating } from './modules/rating.js';
import { initScrollSpy } from './modules/scroll-spy.js';
import { initQuiz } from './modules/quiz.js';
import { initPhoneCode } from './modules/phone-code.js';
import { initSwiper } from './modules/swiper-init.js';
import { initNavbarScroll } from './modules/navbar-scroll.js';
import { initSelect2 } from './modules/select2-init.js';
import { initLessonSwitcher } from './modules/lesson-switcher.js';
import { initOnboarding } from './modules/onboarding.js';
import { initNpsSurvey } from './modules/nps-survey.js';
import { initCookieConsent } from './modules/cookie-consent.js';
import { applyBrandConfig } from './config.js';
import { initFeatures } from './modules/features.js';
import { initRoleGuard } from './modules/role-guard.js';

// Backend injects tenant config before this bundle loads:
// <script>window.__DCCO_TENANT__ = { role: 'instructor', tenant: 'acme', features: { ... }, primaryColor: '...' }</script>
document.addEventListener('DOMContentLoaded', () => {
  applyBrandConfig(window.__DCCO_TENANT__ || {});
  initFeatures();
  initRoleGuard();
  initTheme();
  initDir();
  initSidebar();
  initModals();
  initAccordion();
  initDropdown();
  initNotifications();
  initTabs();
  initToast();
  initToggleSwitch();
  initPasswordToggle();
  initOtpInput();
  initProgressRing();
  initSkeleton();
  initVideoPlayer();
  initRating();
  initScrollSpy();
  initQuiz();
  initPhoneCode();
  initSwiper();
  initNavbarScroll();
  initSelect2();
  initLessonSwitcher();
  initOnboarding();
  initNpsSurvey();
  initCookieConsent();
});
